"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaperIconConfigProvider = exports.paperIconConfigContext = exports.DEFAULT_COLLECTION = exports.DEFAULT_CACHE = void 0;
var react_1 = __importStar(require("react"));
var PaperIconCache_1 = require("./PaperIconCache");
var api_1 = require("./api");
exports.DEFAULT_CACHE = new PaperIconCache_1.PaperIconCache();
exports.DEFAULT_COLLECTION = 'lindua';
exports.paperIconConfigContext = (0, react_1.createContext)({
    cache: exports.DEFAULT_CACHE,
    collection: exports.DEFAULT_COLLECTION,
    env: 'infer',
    fetch: api_1.defaultFetch,
});
var Provider = exports.paperIconConfigContext.Provider;
/**
 * Change the default settings for <PaperIcon>
 */
function PaperIconConfigProvider(_a) {
    var _b;
    var children = _a.children, overrides = __rest(_a, ["children"]);
    var context = (0, react_1.useContext)(exports.paperIconConfigContext);
    var newContext = (0, react_1.useMemo)(function () { return (__assign(__assign({}, context), overrides)); }, __spreadArray([
        context
    ], (_b = []).concat.apply(_b, Object.entries(overrides)), true));
    return react_1.default.createElement(Provider, { value: newContext }, children);
}
exports.PaperIconConfigProvider = PaperIconConfigProvider;
//# sourceMappingURL=PaperIconConfigContext.js.map